import { generateRandomHex } from "./bytes";
const generateBotKey = async ()=>{
    return `sw_bot_${await generateRandomHex()}`;
};
const generateAPIKey = async (postfix)=>{
    return "pk_" + (postfix || "") + await generateRandomHex();
};
export const KeyGenerator = {
    bot: generateBotKey,
    publicAPI: generateAPIKey,
    privateAPI: generateAPIKey
};
